export class AnimationRenderProxy {
    constructor(animator) {
        this.animator = animator;
        this.reset();
    }
    set skinIndex(value) {
        this.currentSKin = this.animator.skinDataArray[value];
    }
    get name() {
        return this.animator.name;
    }
    reset() {
        this.currentTime = -1;
        this.currentFrameIndex = -1;
    }
    renderWithOutMat(slots, updator, curTime) {
        let beforeFrame = this.currentFrameIndex;
        let nowFrame = this.animator.getFrameIndex(curTime, beforeFrame);
        updator.renderUpdate(this.currentSKin, nowFrame, beforeFrame);
        this.currentTime = curTime;
        this.currentFrameIndex = nowFrame;
    }
    render(bones, slots, updator, curTime, boneMat, ofx, ofy) {
        this.renderWithOutMat(slots, updator, curTime);
        this.currentSKin.updateBoneMat(curTime, this.animator, bones, this.state, boneMat, ofx, ofy);
    }
}
